import { staleTimes, useQuery } from '@platform/api-client';
import type { TypedClient } from '@platform/openapi';
import { queryKeys, usePageContext } from '../usePageContext.ts';
import { fetchStockLevels } from './stock-levels.ts';

export const useActiveLocations = (api: TypedClient) => {
  const { tenantId } = usePageContext();
  return useQuery({
    queryKey: queryKeys.locations(tenantId, { status: 'active' }),
    queryFn: () => api.get('/admin/locations', { query: { status: 'active' } }),
    staleTime: staleTimes.reference,
  });
};

export const useStockMatrix = (api: TypedClient, variantIds: readonly string[]) => {
  const { tenantId } = usePageContext();
  const locations = useActiveLocations(api);
  const levels = useQuery({
    queryKey: queryKeys.stockLevels(tenantId, { variantIds }),
    queryFn: () => fetchStockLevels(api, [...variantIds]),
    enabled: variantIds.length > 0,
    staleTime: staleTimes.inventory,
  });
  return {
    locations: locations.data?.items ?? [],
    levels: levels.data?.items ?? [],
    isPending: locations.isPending || (variantIds.length > 0 && levels.isPending),
    isError: locations.isError || levels.isError,
    error: locations.error ?? levels.error,
    refetch: () => {
      void locations.refetch();
      void levels.refetch();
    },
  };
};
